import { Link } from "react-router-dom";
import MarketingLayout from "@/components/layout/MarketingLayout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Wallet, Clock, ShieldCheck, TrendingUp } from "lucide-react";

export default function PersonalLoan() {
  return (
    <MarketingLayout>
      <section className="page-shell px-6 py-20 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 space-y-6">
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Product · Personal Loan</div>
          <h1 className="font-display text-5xl lg:text-6xl leading-[1.05]">Bigger goals, deserving of a bigger plan.</h1>
          <p className="text-lg text-muted-foreground max-w-xl">Loans from ₹50,000 to ₹5,00,000 with flexible tenures of 6 to 36 months. Fixed EMI, transparent pricing, no surprises.</p>
          <div className="flex gap-3 flex-wrap">
            <Link to="/register"><Button size="lg" className="rounded-full brand-gradient text-white" data-testid="pl-apply">Apply Now</Button></Link>
            <Link to="/loan-calculator"><Button size="lg" variant="outline" className="rounded-full">Estimate</Button></Link>
          </div>
        </div>
        <div className="lg:col-span-5">
          <Card className="p-6 rounded-3xl glass">
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Illustrative sanction</div>
            <div className="grid grid-cols-3 gap-3 mt-4">
              <div className="rounded-xl bg-muted p-4"><div className="text-xs">Amount</div><div className="font-display text-2xl">₹2L</div></div>
              <div className="rounded-xl bg-muted p-4"><div className="text-xs">Tenure</div><div className="font-display text-2xl">24 mo</div></div>
              <div className="rounded-xl bg-muted p-4"><div className="text-xs">Rate</div><div className="font-display text-2xl">14%</div></div>
            </div>
            <div className="mt-5 space-y-2 text-sm">
              <div className="flex justify-between"><span className="text-muted-foreground">EMI</span><span>₹9,600</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Total interest</span><span>₹30,400</span></div>
              <div className="flex justify-between font-medium border-t pt-2"><span>Total payable</span><span>₹2,30,400</span></div>
            </div>
          </Card>
        </div>
      </section>

      <section className="page-shell px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
          {[
            { icon: Wallet, t: "₹50K – ₹5,00,000" },
            { icon: Clock, t: "6–36 months" },
            { icon: TrendingUp, t: "14% p.a. onwards" },
            { icon: ShieldCheck, t: "Encrypted & audited" },
          ].map(({ icon: Icon, t }) => (
            <Card key={t} className="p-5 card-hover flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg brand-gradient text-white flex items-center justify-center"><Icon className="h-5 w-5" /></div>
              <div className="text-sm font-medium">{t}</div>
            </Card>
          ))}
        </div>
      </section>

      <section className="page-shell px-6 py-16 grid grid-cols-1 lg:grid-cols-2 gap-8">
        <Card className="rounded-3xl p-8">
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">What can you use it for?</div>
          <ul className="mt-4 space-y-2 text-sm">
            {["Wedding & travel", "Medical expenses", "Home renovation", "Debt consolidation", "Education & upskilling"].map((t) => (
              <li key={t} className="flex items-start gap-2"><CheckCircle2 className="h-4 w-4 text-primary mt-0.5" /><span>{t}</span></li>
            ))}
          </ul>
        </Card>
        <Card className="rounded-3xl p-8">
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Charges (illustrative)</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li>Interest: 14–22% p.a.</li>
            <li>Processing fee: 1–2% + GST</li>
            <li>Prepayment: Nil to 2% (product-specific)</li>
            <li>Bounce charges: ₹500 + GST per instance</li>
          </ul>
        </Card>
      </section>
    </MarketingLayout>
  );
}
